import {Component, computed, input, output} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {LoadError} from 'src/app/services/shared/load-error.model';
import {IconTextButtonComponent} from '../icon-text-button/icon-text-button.component';

/** The messenger loaded by the Intercom snippet (index.html), absent until it is ready. */
type IntercomWindow = Window & {Intercom?: (command: string) => void};

/**
 * What a screen shows in place of content it could not load, where that content was expected; the rest of the page
 * stays usable (KAB-2441). `page` for the main content of a page or drawer, `block` for a list, a tab or a widget,
 * `compact` for a small widget or a cell. Only an `unavailable` error offers to retry: not a refusal, nor a deleted item.
 */
@Component({
	selector: 'app-error-state',
	imports: [TranslatePipe, IconTextButtonComponent],
	templateUrl: './error-state.component.html',
	styleUrl: './error-state.component.scss',
	host: {role: 'status', '[class]': 'size()'},
})
export class ErrorStateComponent {
	readonly error = input.required<LoadError>();
	readonly size = input<'page' | 'block' | 'compact'>('block');
	readonly retry = output<void>();

	protected readonly key = computed(() => `global.loadError.${this.error()}`);
	protected readonly canRetry = computed(() => this.error() === 'unavailable');

	/** A retry is not a click on what holds the error: a tile that opens a page, a row that opens a drawer. */
	protected onRetry(event: Event): void {
		event.stopPropagation();
		this.retry.emit();
	}

	protected openChat(): void {
		(window as IntercomWindow).Intercom?.('show');
	}
}
